var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defaultRendererConfig, setupBingAerialImagery } from "./index";
import { sceneFlyover } from "./utils/sceneFlyover";
import { DURATIONS, FOCUSES, POINT_COLORS, POINT_PICKING_USER_IDS, POINT_VERTICES, POSITIONS, } from "./utils/standardPrimitiveData";
export function primitivePoint1(container, description) {
    return __awaiter(this, void 0, void 0, function* () {
        description.innerHTML =
            "<h1>" +
                "Primitive Point 1" +
                "</h1>" +
                "<p>" +
                "The camera will be looking at a primitive points object. It should render normally." +
                "</p>";
        yield sceneFlyover(defaultRendererConfig(container), DURATIONS, POSITIONS, FOCUSES, (renderer) => __awaiter(this, void 0, void 0, function* () {
            // Scene setup
            setupBingAerialImagery(renderer);
            const points = renderer.createPointMesh();
            points.points = POINT_VERTICES;
            points.color = POINT_COLORS;
            points.pickingUserId = POINT_PICKING_USER_IDS;
            points.resolve();
            const object = renderer.getObjectFactory().createRawMeshObject({
                position: {
                    cartographic: {
                        longitude: 2.633667667706,
                        latitude: -0.601510430485,
                        height: 5,
                    },
                },
                mesh: points,
                material: {
                    type: "basicOpaque",
                    color: { r: 1, g: 1, b: 1 },
                    pointSize: 3,
                    vertexColors: true,
                },
            });
            renderer.getWorld().addObject(object);
        }));
    });
}
